import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import { getDropdownMenuOption } from '~/utils/menuOptions/getDropdownMenuOption';

type GetHelpMenuOptionsParams = {
  onChatWithSales: () => void;
  onChatWithSupport: () => void;
  onHelpCenter: () => void;
  onLeaveFeedback?: () => void;
  onTapNewAtAir?: () => void;
};

export const getHelpMenuOptions = ({
  onChatWithSales,
  onChatWithSupport,
  onHelpCenter,
  onLeaveFeedback,
  onTapNewAtAir,
}: GetHelpMenuOptionsParams): DropdownMenuOption[] => {
  const optionsArray: DropdownMenuOption[] = [
    {
      ...getDropdownMenuOption('help-center'),
      onSelect: onHelpCenter,
      type: 'item',
    },
    {
      ...getDropdownMenuOption('chat-with-support'),
      onSelect: onChatWithSupport,
      type: 'item',
    },
    {
      ...getDropdownMenuOption('meet-with-sales'),
      onSelect: onChatWithSales,
      type: 'item',
    },
  ];

  if (onTapNewAtAir) {
    optionsArray.push({
      ...getDropdownMenuOption('new-at-air'),
      onSelect: onTapNewAtAir,
      type: 'item',
    });
  }

  if (onLeaveFeedback) {
    optionsArray.push({
      ...getDropdownMenuOption('leave-feedback'),
      onSelect: onLeaveFeedback,
      type: 'item',
    });
  }

  return optionsArray;
};
